import { forwardRef, useContext } from 'react';
import clsx from 'clsx';
import { Component } from '@headless-workspace/typings';
import { TabsTrigger, TabsContent } from '@radix-ui/react-tabs';
import { GlowTextBody, PropsWithFontFamily, PropsWithId } from '../../..';
import { IdContext } from './IdProvider';

export type TabLabelProps = Required<PropsWithId> &
    PropsWithFontFamily & {
        label: string;
    };

const Label = forwardRef<HTMLButtonElement, TabLabelProps>(({ id, label, fontFamily }, ref) => {
    const isCurrent = useContext(IdContext) === id;

    return (
        <TabsTrigger ref={ref} className={'flex-none relative'} value={id}>
            <GlowTextBody TagName={'span'} fontFamily={fontFamily} text={label} className={'block p-1'} />
            {isCurrent && (
                <span
                    className={clsx(
                        'absolute bottom-0 left-1 right-1',
                        'border-b-strong border-solid border-b-border-brand',
                    )}
                />
            )}
        </TabsTrigger>
    );
});

export type TabContentProps = Required<PropsWithId> & {
    Content: Component;
};

const Content: Component<TabContentProps> = ({ id, Content }) => {
    return (
        <TabsContent value={id}>
            <Content />
        </TabsContent>
    );
};

export const Tab = {
    Label,
    Content,
};
